module.exports = __webpack_public_path__ + "img/deco_heart.7420bf7f.webp";